// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3-dgk-wAU3lGgs7ktk-pG9","icon":"icon-2MZ548M7o5zdF-utxG4uhX"};